import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import OpenAILogo from "../static/openai-logomark.svg";

const INK = "#0f1121";
const INK_SOFT = "rgba(15, 17, 33, 0.62)";
const INK_MUTED = "rgba(15, 17, 33, 0.55)";
const INK_FAINT = "rgba(15, 17, 33, 0.42)";
const INK_HAIRLINE = "rgba(15, 17, 33, 0.08)";
const ACCENT = "#3854e8";
const SURFACE = "#ffffff";

const SANS = "'sohne-var', 'Helvetica Neue', 'Arial', sans-serif";
const MONO =
  "'JetBrains Mono', 'Söhne Mono', ui-monospace, SFMono-Regular, Menlo, monospace";

const linkSx = {
  fontFamily: SANS,
  fontSize: "0.88rem",
  fontWeight: 500,
  color: INK_SOFT,
  textDecoration: "none",
  transition: "color 0.15s ease",
  "&:hover": { color: INK }
};

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: SURFACE,
        borderTop: `1px solid ${INK_HAIRLINE}`,
        py: { xs: 5, md: 7 },
        px: { xs: 2, sm: 3 },
        textAlign: "left"
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              md: "minmax(0, 4fr) minmax(0, 4fr) minmax(0, 4fr)"
            },
            gap: { xs: 3, md: 5 },
            alignItems: "center"
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.25,
              flexWrap: "wrap"
            }}
          >
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1
              }}
            >
              <Box
                sx={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  backgroundColor: ACCENT
                }}
              />
              <Typography
                sx={{
                  fontFamily: SANS,
                  fontSize: "0.92rem",
                  fontWeight: 600,
                  letterSpacing: "-0.005em",
                  color: INK
                }}
              >
                Interview Lab
              </Typography>
            </Box>
            <Typography
              sx={{
                fontFamily: MONO,
                fontSize: "0.68rem",
                letterSpacing: "0.18em",
                textTransform: "uppercase",
                color: INK_FAINT,
                fontVariantNumeric: "tabular-nums"
              }}
            >
              © {new Date().getFullYear()}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              justifySelf: { xs: "flex-start", md: "center" }
            }}
          >
            <Typography
              sx={{
                fontFamily: MONO,
                fontSize: "0.68rem",
                letterSpacing: "0.18em",
                textTransform: "uppercase",
                color: INK_MUTED
              }}
            >
              Powered by GPT-4 + Whisper
            </Typography>
            <Box
              component="img"
              src={OpenAILogo}
              alt="OpenAI"
              sx={{
                height: 14,
                width: "auto",
                opacity: 0.55,
                filter: "saturate(0)"
              }}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2.25,
              flexWrap: "wrap",
              justifySelf: { xs: "flex-start", md: "flex-end" }
            }}
          >
            <Box component={RouterLink} to="/privacy" sx={linkSx}>
              Privacy
            </Box>
            <Box
              sx={{
                width: 3,
                height: 3,
                borderRadius: "50%",
                backgroundColor: INK_HAIRLINE
              }}
            />
            <Box component={RouterLink} to="/terms" sx={linkSx}>
              Terms
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
